import { useRef, useEffect } from "react";
import { Field } from "react-final-form";
import { FormFieldDependenceRuleProps } from "./FormFieldDependenceRule.props";

export const FormFieldDependenceRule = ({
  fieldName,
  dependentFieldName,
  checkboxDependency = false,
  checkPredicate,
  updatePredicate
}: FormFieldDependenceRuleProps) => {
  return (
    <Field
      name={dependentFieldName}
      type={checkboxDependency ? "checkbox" : undefined}
      render={({ input: { onChange, value: dependentFieldValue } }) => {
        return (
          <Field
            name={fieldName}
            render={({ input: { value, checked } }) => {
              const currentValue = checkboxDependency ? checked : value;

              const previousValueRef = useRef<typeof value>(undefined);
              const hasInitializedRef = useRef(false);

              useEffect(() => {
                if (!hasInitializedRef.current) {
                  previousValueRef.current = currentValue;
                  hasInitializedRef.current = true;
                  return;
                }

                if (currentValue !== previousValueRef.current) {
                  if (checkPredicate && !checkPredicate(previousValueRef.current, currentValue)) {
                    previousValueRef.current = currentValue;
                    return;
                  }

                  const result = updatePredicate(
                    previousValueRef.current,
                    currentValue,
                    dependentFieldValue
                  );
                  onChange(result);
                  previousValueRef.current = currentValue;
                }
              }, [currentValue, dependentFieldValue, onChange, checkPredicate, updatePredicate]);

              return null;
            }}
          />
        );
      }}
    />
  );
};
